const TrendingProductData =[
    {
        TrendingProductTitle:'Grass Cutter',
        TrendingProductPrice:'35,500.00',
        TrendingProductImage:'../product-image/Grass-Cutter.png',
    },
    {
        TrendingProductTitle:'Animal Loader Scale',
        TrendingProductPrice:'75,500.00',
        TrendingProductImage:'../product-image/Loader-Scale.png',
    },
    {
        TrendingProductTitle:'Weight Machine',
        TrendingProductPrice:'4,500.00',
        TrendingProductImage:'../product-image/Weight-Scale.png',
    },
    {
        TrendingProductTitle:'Animal-Mattress',
        TrendingProductPrice:'10,500.00',
        TrendingProductImage:'../product-image/Animal-Mattress.png',
    },
    {
        TrendingProductTitle:'Animal Room Tube Light',
        TrendingProductPrice:'5,000.00',
        TrendingProductImage:'../product-image/tube-light.png',
    },
    {
        TrendingProductTitle:'Sprayer-Machine',
        TrendingProductPrice:'15,500.00',
        TrendingProductImage:'../product-image/spare-machine2.png',
    }
    ,
    {
        TrendingProductTitle:'Room Hitter',
        TrendingProductPrice:'18,000.00',
        TrendingProductImage:'../product-image/room-hitter.png',
    },
    {
        TrendingProductTitle:'Milk Machine',
        TrendingProductPrice:'25,000.00',
        TrendingProductImage:'../product-image/Milking-Machine-02.png',
    }
]
export default TrendingProductData;